import { PillToggle } from "src/base-components/PillToggle";

/**
 * Toggle between JSON and UI mode for schema diffs.
 */
export type ModeToggleProps = {
  mode: "json" | "ui";
};

type Props = {
  value: ModeToggleProps["mode"];
  onChange: (mode: ModeToggleProps["mode"]) => void;
};

export const SchemaModeToggle: React.FC<Props> = ({ value, onChange }) => {
  return (
    <PillToggle value={value} onChange={onChange}>
      <PillToggle.Button value="ui">UI</PillToggle.Button>
      <PillToggle.Button value="json">JSON</PillToggle.Button>
    </PillToggle>
  );
};
